export const FACILITY_ROLES = [
    {
        id: 'facility_admin',
        label: 'Facility Admin',
        description: 'Full access. Manage team, settings, and all cases.',
        tone: 'teal',
    },
    {
        id: 'case_manager',
        label: 'Clinical Liaison',
        description: 'Create and manage cases. Cannot manage team.',
        tone: 'slate',
    },
    {
        id: 'nurse',
        label: 'Nurse',
        description: 'Fill out per-patient visit forms only.',
        tone: 'amber',
    },
];

const ROLE_INDEX = Object.fromEntries(FACILITY_ROLES.map((r) => [r.id, r]));

export function roleLabel(id) {
    if (id == null) return '—';
    return ROLE_INDEX[id]?.label ?? id;
}

export function roleDescription(id) {
    return ROLE_INDEX[id]?.description ?? '';
}

export function roleTone(id) {
    return ROLE_INDEX[id]?.tone ?? 'slate';
}

export function facilityConfigTypeLabel(value) {
    if (!value) return '';
    return value
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}
